import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const services = [
  "Web Development",
  "Mobile App Development",
  "UI/UX Design",
  "Machine Learning",
  "Cloud Computing",
  "Data Analytics"
];

const Home = () => {
  const videos = [
    // "/videos/Vid 1.mp4",
    // "/videos/Vid 2.mp4",
    "/videos/web vid 1.mp4 ",
    "/videos/web vid 2.mp4",
    "/videos/web vid 3.mp4",
    "/videos/web vid 4.mp4",
    
  ];
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [fade, setFade] = useState(true);
  const [displayedServices, setDisplayedServices] = useState([]);
  const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length);
        setFade(true);
      }, 500); // Half of transition time for smooth effect
    }, 3000); // Change video every 3 seconds

    return () => clearInterval(interval);
  }, [videos.length]);

  useEffect(() => {
    if (isTyping) {
      const service = services[currentServiceIndex];
      if (currentText.length < service.length) {
        const timeout = setTimeout(() => {
          setCurrentText(service.slice(0, currentText.length + 1));
        }, 100); // Typing speed
        return () => clearTimeout(timeout);
      } else {
        // Finished typing, add to displayed services and pause
        setTimeout(() => {
          setDisplayedServices(prev => [...prev, service]);
          setIsTyping(false);
          setTimeout(() => {
            if (currentServiceIndex === services.length - 1) {
              // All services displayed, reset and start over
              setDisplayedServices([]);
              setCurrentServiceIndex(0);
              setCurrentText("");
              setIsTyping(true);
            } else {
              // Move to next service
              setCurrentServiceIndex((prev) => prev + 1);
              setCurrentText("");
              setIsTyping(true);
            }
          }, 2000); // Pause before next service or reset
        }, 500); // Pause after typing
      }
    }
  }, [currentText, currentServiceIndex, isTyping]);

  return (
    <div className="pt-20 ">
     <section className="relative w-full h-screen overflow-hidden flex flex-col md:flex-row items-center justify-between px-8 bg-[#030303] text-white">
  {/* Blurred Background Video with Rotation */}
  <div className="absolute top-0 left-0 w-full h-full overflow-hidden">
    <video
      key={currentVideoIndex} // Force re-render on video change
      className={`w-full h-full object-cover transition-opacity duration-1000 ease-in-out ${fade ? 'opacity-100' : 'opacity-0'}`}
      src={videos[currentVideoIndex]}
      autoPlay
      loop
      muted
      playsInline
    />
    {/* Gradient Overlay for Better Text Readability */}
    <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-transparent to-black/60"></div>
  </div>

  {/* Foreground Content */}
  <div className="relative z-10 flex flex-col md:flex-row items-center justify-between w-full h-full px-8">
    {/* Left Side Content */}
    <div className="flex-1 space-y-6 z-20 text-center md:text-left max-w-lg">
      <h1 className="text-4xl md:text-5xl font-bold text-white">
        We Build <span className="text-blue-600">Innovative</span> Digital Solutions
      </h1>
      <p className="text-white text-lg">
        Welcome to{" "}
        <span className="font-bold text-blue-500 cursor-pointer">ezeeta</span> — your one-stop
        partner for modern web & app development, branding, and creative solutions.
      </p>

      <div className="flex gap-4 justify-center md:justify-start">
        <Link
          to="/projects"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg shadow hover:bg-blue-700 transition-all duration-300"
        >
          View Our Work
        </Link>
        <Link
          to="/contact"
          className="border border-white text-white px-6 py-3 rounded-lg hover:bg-blue-600 hover:text-white transition-all duration-300"
        >
          Contact Us
        </Link>
      </div>
    </div>

    {/* Right Side Services Section */}
    <div className="flex-1 flex flex-col justify-center items-end z-20 space-y-6">
      {/* Beautiful Heading */}
      <div className="text-right">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-2">
          Our <span className="text-blue-500">Services</span>
        </h2>
        <div className="w-24 h-1 bg-blue-500 rounded-full"></div>
      </div>

      {/* Services List */}
      <div className="w-80 text-right space-y-3">
        {displayedServices.map((service, index) => (
          <div
            key={index}
            className="text-white text-lg font-medium animate-fade-in"
            style={{ animationDelay: `${index * 0.2}s` }}
          >
            • {service}
          </div>
        ))}
        {isTyping && (
          <div className="text-white text-lg font-medium">
            • {currentText}<span className="animate-pulse">|</span>
          </div>
        )}
      </div>
    </div>
  </div>
</section>

      {/* About Section */}
      <section className="px-8 py-16 text-center">
        <h2 className="text-3xl font-bold mb-4 text-white">Who We Are</h2>
        <p className="text-white max-w-2xl mx-auto">
          We are a creative team passionate about crafting impactful digital experiences.
          From strategy to execution, we help businesses grow through innovative
          technology and design.
        </p>
      </section>
      {/* Contact CTA Section */}
      <section className="relative px-8 py-20 text-white text-center overflow-hidden">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src="/videos/web vid 2.mp4" // 👉 place your video in public/videos/
        autoPlay
        loop
        muted
        playsInline
      ></video>

      {/* Blur Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>

      {/* Content */}
      <div className="relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Ready to Start Your Project?
        </h2>
        <p className="text-lg mb-6 text-gray-200">
          Let’s collaborate and turn your ideas into reality.
        </p>

        <Link
          to="/contact"
          className="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-slate-600 transition-all duration-300"
        >
          Get in Touch
        </Link>
      </div>
    </section>
    </div>
  );
};

export default Home;
